import React from "react";
import { useTranslation } from "react-i18next";
import {
  AlarmInfo,
  AlarmKmRange,
  AlarmLimit,
} from "../../master/common/AlarmView";
import { ColorPicker } from "@progress/kendo-react-inputs";

const AlarmViewer = ({
  alarm,
  action,
  index,
  onEditAlarm,
  onAlarmToggleEnable,
  item,
  onParamBgColorChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex py-1" key={index}>
      <div class="dark:bg-neutral-800 bg-gray2  rounded-lg w-11/12 lg:w-fit h-fit px-3 py-2">
        <div className="flex gap-3 ml-1">
          <div className="flex flex-col gap-3 text-xs lg:text-sm py-1 w-40 pr-3 border-r-2 border-zinc-700">
            <div className="flex w-24 dark:text-white text-black">
              <label className="dark:text-white text-black text-xs lg:text-sm font-medium">
                {t("masters.fields.alrmName")}
              </label>
            </div>
            <div className="flex w-36 dark:text-white text-black">
              <label>{alarm.alarmName}</label>
            </div>
          </div>
          {/* Alarm Info */}
          {alarm.infoEnabled === true &&
            (alarm.parameterType === "String" ||
            alarm.parameterType === "Boolean" ? (
              <AlarmInfo
                label={t("masters.fields.info")}
                value={alarm.infoSensorValue}
                text={alarm.infoAlarmText}
                t={t}
              />
            ) : alarm.parameterType === "Number" ? (
              <AlarmLimit
                label={t("masters.fields.info")}
                min={alarm.infoLowerLimit}
                max={alarm.infoUpperLimit}
                t={t}
              />
            ) : alarm.parameterType === "GeoLocation" ? (
              <AlarmKmRange
                label={t("masters.fields.info")}
                value={alarm.infoKMRange}
                t={t}
              />
            ) : null)}

          {/* Warning Info */}
          {alarm.warningEnabled === true &&
            (alarm.parameterType === "String" ||
            alarm.parameterType === "Boolean" ? (
              <AlarmInfo
                label={t("masters.fields.warning")}
                value={alarm.warningSensorValue}
                text={alarm.warningAlarmText}
                t={t}
              />
            ) : alarm.parameterType === "Number" ? (
              <AlarmLimit
                label={t("masters.fields.warning")}
                min={alarm.warningLowerLimit}
                max={alarm.warningUpperLimit}
                t={t}
              />
            ) : alarm.parameterType === "GeoLocation" ? (
              <AlarmKmRange
                label={t("masters.fields.warning")}
                value={alarm.infoKMRange}
                t={t}
              />
            ) : null)}

          {/* Critical Info */}
          {alarm.criticalEnabled === true &&
            (alarm.parameterType === "String" ||
            alarm.parameterType === "Boolean" ? (
              <AlarmInfo
                label={t("masters.fields.critical")}
                value={alarm.criticalSensorValue}
                text={alarm.criticalAlarmText}
                t={t}
              />
            ) : alarm.parameterType === "Number" ? (
              <AlarmLimit
                label={t("masters.fields.critical")}
                min={alarm.criticalLowerLimit}
                max={alarm.criticalUpperLimit}
                t={t}
              />
            ) : alarm.parameterType === "GeoLocation" ? (
              <AlarmKmRange
                label={t("masters.fields.critical")}
                value={alarm.infoKMRange}
                t={t}
              />
            ) : null)}
          <div className="flex flex-col gap-3">
            <label>{t("masters.fields.alrmBg")}</label>
            <ColorPicker
              view="gradient"
              id="colorInput"
              popupSettings={{ backgroundColor: "rgb(229,231,235)" }}
              // className="colorInput p-0 h-full w-full bg-white border border-gray-200 cursor-pointer rounded-lg"
              value={item?.cardBgColor || "transparent"}
              onChange={(e) => onParamBgColorChange(e, item)}
            />
          </div>

          {/* Edit Button */}
          {action && (
            <div className="flex justify-center items-center">
              <div className="flex h-full w-10 justify-center items-center ">
                <button
                  type="button"
                  className="h-10 w-9 dark:bg-neutral-900 bg-zinc-500 flex rounded-lg justify-center items-center"
                  onClick={(e) => onEditAlarm(e, alarm, index, item)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-4 h-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col mt-5" id="propTypecombo">
        <label className="flex items-center placeholder:text-white rounded-lg mb-4 text-white px-5">
          <div
            className={`inline-flex rounded-xl group mt-1 h-8 border-2 ${
              alarm.enabled === true
                ? "bg-lime-700 border-lime-700"
                : "bg-lime-700 border-lime-700"
            }`}
          >
            <button
              type="button"
              className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                alarm.enabled === true
                  ? "bg-lime-700 text-white"
                  : "text-white bg-white"
              }`}
              onClick={(e) => onAlarmToggleEnable(e, alarm.parameterId)}
            >
              {t("masters.labels.enabled")}
            </button>
            <button
              type="button"
              className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                alarm.enabled === true
                  ? "text-white bg-white"
                  : "bg-lime-700 text-white"
              }`}
              onClick={(e) => onAlarmToggleEnable(e, alarm.parameterId)}
            >
              {t("masters.labels.disabled")}
            </button>
          </div>
        </label>
      </div>
    </div>
  );
};

export default AlarmViewer;
